module.exports = __webpack_public_path__ + "img/balloon3.73b39ffd.png";